import type { FaireReviewEntity } from "../../entity_types/review";

// Real Softies review, read off the brand's public Faire product-reviews API
// (Ryan, 2026-09-02) — verbatim comment, real reviewer, real shop, real date.
// `review_sof*` prefix keeps these from colliding with another brand's files.
export const review_sof3: FaireReviewEntity = {
  token: "review_sof3",
  type: "review",
  brandName: "Softies",
  brandToken: "b_br6ji29u",
  reviewType: "product",
  productToken: "p_sfmywzj52b",
  reviewerName: "Ingrid",
  reviewerLocation: "Southlake, TX",
  stars: 5,
  reviewText: "We got many “refills” from Softies and we became famous in the area during the holidays because of the marshmallow loungewear. People we’ve never seen before coming in asking where they were. Everyone loved it! The price is much better than the competition and the quality is just amazing.",
  reviewDate: "Feb 24, 2025",
  meta: {
    source: "api",
    importedAt: "2026-09-02T00:00:00.000Z",
    importedBy: "entity-db-cli",
  },
};
